define.alias("shared/components/shared/post/secondary/hashtag-suggestions/table", "settings/components/shared/post/secondary/hashtag-suggestions/table");